module.exports = __webpack_public_path__ + "static/img/data.149ee3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/data.png
// module id = 450
// module chunks = 1 2 3 4 5 6 7 8